import {
  codeBenchActions,
  launchPageActions,
  mergeCasesActions
} from '@codametrix/ui-common';
import './styles/index.scss';
const {
  navigatePatient,
  navigateDetail,
  showHoldCaseModal,
  hideHoldCaseModal,
  showExclusionCaseModal,
  hideExclusionCaseModal,
  toggleLateCaseClearModal,
  clearLateCaseNotification,
  showSplitCaseModal,
  hideSplitCaseModal,
  toggleSubmitOldCaseModal,
  getCaseVersions,
  showCaseCommentModal,
  hideCaseCommentModal,
  openWindow
} = codeBenchActions;

const {
  showMergeCasesModal,
  hideMergeCasesModal,
  splitCase
} = mergeCasesActions;

export const mapStateToCodeBenchActionBarProps = (
  state: any
): Accelerate.CodeBenchActionBarData => {
  return {
    activeItem: state.codeBench.activeItem,
    loadState: state.codeBench.loadState,
    processInstanceGuids: state.ui.contextParams.processInstanceGuids || [],
    processInstance: state.codeBench.processInstance,
    cases: state.codeBench.cases,
    counts: state.codeBench.counts,
    benchEditable: state.codeBench.benchEditable,
    toggleHoldCaseModal: state.codeBench.toggleHoldCaseModal,
    toggleExclusionCaseModal: state.codeBench.toggleExclusionCaseModal,
    showLateCaseClearModal: state.codeBench.showLateCaseClearModal,
    toggleSplitCaseModal: state.codeBench.toggleSplitCaseModal,
    submitOldCaseModal: state.codeBench.submitOldCaseModal,
    holdCaseStatus: state.codeBench.holdCase,
    improvements: state.codeBench.improvements,
    userContext: state.codeBench.userContext,
    caseAccessTime: state.codeBench.caseAccessTime,
    benchMode: state.codeBench.benchMode
  };
};

export const mapDispatchToCodeBenchActionBarProps = (
  dispatch: any
): Accelerate.CodeBenchActionBarMethods => {
  return {
    openChildWindow: (windowOpenArgs: CMxCommonApp.WindowOpenArguments) => {
      dispatch(openWindow(windowOpenArgs));
    },
    showPatientInfo: caseRun => {
      dispatch(navigatePatient(caseRun));
    },
    handleTraversal: (caseDescriptor: string) => {
      dispatch(navigateDetail(caseDescriptor));
    },
    showHoldCaseModal: () => {
      dispatch(showHoldCaseModal());
    },
    hideHoldCaseModal: () => {
      dispatch(hideHoldCaseModal());
    },
    showCaseCommentModal: () => {
      dispatch(showCaseCommentModal());
    },
    hideCaseCommentModal: () => {
      dispatch(hideCaseCommentModal());
    },
    showMergeCasesModal: (
      mergeCaseModalProps: CMxCommonApp.MergeCaseModalProps
    ) => {
      dispatch(showMergeCasesModal(mergeCaseModalProps));
    },
    hideMergeCasesModal: () => {
      dispatch(hideMergeCasesModal());
    },
    showExclusionCaseModal: () => {
      dispatch(showExclusionCaseModal());
    },
    hideExclusionCaseModal: () => {
      dispatch(hideExclusionCaseModal());
    },
    toggleLateCaseClearModal: (toggle: boolean) => {
      dispatch(toggleLateCaseClearModal(toggle));
    },
    clearLateCaseNotification: (
      processInstance: AmplifyAPI.ProcessInstance
    ) => {
      dispatch(clearLateCaseNotification(processInstance));
    },
    showSplitCaseModal: () => {
      dispatch(showSplitCaseModal());
    },
    hideSplitCaseModal: () => {
      dispatch(hideSplitCaseModal());
    },
    navigate: (url: string) => {
      dispatch(launchPageActions.navigationIntent({ intent: 'CASE_DETAIL', url }));
    },
    toggleSubmitOldCaseModal: () => {
      dispatch(toggleSubmitOldCaseModal());
    },
    getCaseVersions: async (processInstance: AmplifyAPI.ProcessInstance) => {
      await dispatch(getCaseVersions(processInstance));
    },
    splitCase: (processInstance: AmplifyAPI.ProcessInstance) => {
      dispatch(splitCase(processInstance));
    }
  };
};

import { commonEnums } from '@codametrix/ui-common';

const { CursorOperation } = commonEnums;

function createSubmitCaseHandler(
  UIMode: commonEnums.UIModesEnum,
  onInvoicesSubmisson: (processInstance: AmplifyAPI.Submission) => void,
  processInstance: AmplifyAPI.ProcessInstance,
  cursorAPIContext: CMxCommonApp.CursorAPIContext,
  caseAccessTime: string,
  activeItem: any,
  getCaseVersions: (processInstance: AmplifyAPI.ProcessInstance) => void,
  toggleSubmitOldCaseModal: (input: string) => void,
  hasAmplifyCaseRunV2Access: boolean,
  releaseCurrentCaseAccess: () => void,
) {
  return async (
    event: React.MouseEvent,
    vwComment: string = null,
    isCodeableVersion: boolean
  ) => {
    event.preventDefault();

    releaseCurrentCaseAccess();
    const button = event.currentTarget as HTMLButtonElement;
    button.disabled = true;

    const cursorAPIPayload: CMxCommonApp.CursorAPIPayload = {
      operation: CursorOperation.NEXT,
      cursorAPIContext,
      hasAmplifyCaseRunV2Access
    };

    try {
      await getCaseVersions(processInstance);

      if (isCodeableVersion) {
        await onInvoicesSubmisson({
          processInstance: processInstance,
          uiMode: UIMode,
          vwComment,
          cursorAPIPayload,
          submitWithOverrideButton: false,
          caseAccessTime,
          activeItem: activeItem
        });
      } else {
        toggleSubmitOldCaseModal('');
      }
    } finally {
      button.disabled = false;
    }
  };
}

function createSubmitCQAWorkItemHandler(
  cursorAPIContext,
  submitWorkItem,
  status,
  releaseCurrentCaseAccess
) {
  return async (
    event: React.MouseEvent,
    vwComment: string = null,
    isCodeableVersion: boolean
  ) => {
    event.preventDefault();

    const button = event.currentTarget as HTMLButtonElement;
    button.disabled = true;

    const cursorAPIPayload: CMxCommonApp.CursorAPIPayload = {
      operation: CursorOperation.NEXT,
      cursorAPIContext
    };

    try {
      submitWorkItem(cursorAPIPayload, status, releaseCurrentCaseAccess);
    } finally {
      button.disabled = false;
    }
  };
}

export { createSubmitCaseHandler, createSubmitCQAWorkItemHandler };
